import { createBrowserRouter } from "react-router-dom";
import { importWithReload } from "./utils/lazyWithReload";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { Trips } from "./pages/Trips";
import { TripCreate } from "./pages/TripCreate";
import { TripDetail } from "./pages/TripDetail";
import { SegmentDetail } from "./pages/SegmentDetail";
import { InteractionDetail } from "./pages/InteractionDetail";
import { StayDetail } from "./pages/StayDetail";
import { Entities } from "./pages/Entities";
import { EntityCreate } from "./pages/EntityCreate";
import { LinkActivities } from "./pages/LinkActivities";
import { EntityDetail } from "./pages/EntityDetail";
import { Connections } from "./pages/Connections";
import { TypeDefaults, TypeDefaultsList } from "./pages/TypeDefaults";
import { Search } from "./pages/Search";

// Pages that pull in heavy libraries or that only admins open load on first
// visit rather than with the app: the Journey map brings Leaflet (~150 KB),
// and the admin pages bring the mock-location map. Every chunk is precached
// by the service worker, so they still open offline.
const journey = () => importWithReload(() => import("./pages/Journey")).then((m) => ({ Component: m.Journey }));
const users = () => importWithReload(() => import("./pages/Users")).then((m) => ({ Component: m.Users }));
const adminJobs = () => importWithReload(() => import("./pages/AdminJobs")).then((m) => ({ Component: m.AdminJobs }));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "trips", element: <Trips /> },
      { path: "trips/new", element: <TripCreate /> },
      { path: "trips/:tripId", element: <TripDetail /> },
      { path: "trips/:tripId/segments/:segmentId", element: <SegmentDetail /> },
      { path: "trips/:tripId/interactions/:interactionId", element: <InteractionDetail /> },
      { path: "trips/:tripId/stays/:stayId", element: <StayDetail /> },
      { path: "trips/:tripId/journey", lazy: journey },
      { path: "journey", lazy: journey },
      { path: "entities", element: <Entities /> },
      { path: "entities/new", element: <EntityCreate /> },
      { path: "entities/link", element: <LinkActivities /> },
      { path: "entities/:entityId", element: <EntityDetail /> },
      { path: "types", element: <TypeDefaultsList /> },
      { path: "types/:type", element: <TypeDefaults /> },
      { path: "connections", element: <Connections /> },
      { path: "search", element: <Search /> },
      { path: "users", lazy: users },
      { path: "admin", lazy: adminJobs },
    ],
  },
]);
